/**
 * Small reusable label used across the sales demo to clearly mark
 * sample / demonstration content so it is never mistaken for real data.
 */
export default function DemoBadge({ label = 'Demo content', tone = 'light' }: { label?: string; tone?: 'light' | 'dark' }) {
  if (tone === 'dark') {
    return (
      <span className="inline-flex items-center gap-1.5 bg-foreground-800 text-background-100 font-label font-bold uppercase tracking-widest text-[10px] px-2.5 py-1 rounded-sm whitespace-nowrap">
        <span className="w-3.5 h-3.5 flex items-center justify-center"><i className="ri-flask-line"></i></span>
        {label}
      </span>
    );
  }
  return (
    <span className="inline-flex items-center gap-1.5 bg-secondary-100 text-secondary-900 border border-secondary-200 font-label font-bold uppercase tracking-widest text-[10px] px-2.5 py-1 rounded-sm whitespace-nowrap">
      <span className="w-3.5 h-3.5 flex items-center justify-center"><i className="ri-flask-line"></i></span>
      {label}
    </span>
  );
}